import React, { FC } from "react";

import SectionWithTitle from "src/components/SectionWithTitle";
import SchemaPropertiesTable from "src/components/index/schemas/SchemaPropertiesTable";
import { SubjectQuery } from "src/lib/graphql/types";

const SubjectBody: FC<{ schema: SubjectQuery["subject"] }> = ({ schema }) => {
  const { canUserEdit, name, namespace, properties, type } = schema;

  if (!properties && !canUserEdit) {
    return (
      <p>
        {type === "DataType"
          ? "This is a primitive data type. It has no properties."
          : "This type has no properties."}
      </p>
    );
  }

  const directProperties = properties?.find(
    ({ schema: schemaRef }) =>
      name === schemaRef.name && namespace === schemaRef.namespace
  );

  const inheritedProperties = properties?.filter(
    ({ schema: schemaRef }) =>
      !(name === schemaRef.name && namespace === schemaRef.namespace)
  );

  return (
    <div className="schema-property-tables">
      {(directProperties || canUserEdit) && (
        <SectionWithTitle
          title="Own Properties"
          className="schema-body-left own-properties"
        >
          <SchemaPropertiesTable
            canUserEdit={canUserEdit}
            name={name}
            namespace={namespace}
            properties={directProperties?.properties ?? []}
            primary={true}
            version={schema.version}
            key={name}
          />
        </SectionWithTitle>
      )}
      {!!inheritedProperties?.length && (
        <SectionWithTitle
          title="Inherited Properties"
          className="schema-body-left"
        >
          {inheritedProperties?.map((propertiesBySchema) => {
            const {
              schema: propertiesSchemaKey,
              properties,
            } = propertiesBySchema;

            return (
              <SchemaPropertiesTable
                name={propertiesSchemaKey.name}
                namespace={propertiesSchemaKey.namespace}
                properties={properties}
                version={schema.version}
                key={propertiesSchemaKey.name}
              />
            );
          })}
        </SectionWithTitle>
      )}
    </div>
  );
};

export default SubjectBody;
